import { defineMessages } from 'react-intl';

const messages = defineMessages({
  mpc_no: '供应商编号',
  full_name: '公司全称',
  short_name: '简称',
  identifier: '标识符',
  service_content: '服务内容',
  supplier_type: '供应商等级',
  service_type: '服务类型',
  advance_payment: '垫支量级',
  address: '公司地址',
  parent_company: '父公司',
  parent_company_tips: '（若无父公司，请留空）',
  region: '区域',
  status: '状态',
  referrer_name: '推荐人',
  recommend_group_name: '推荐项目组',
  recommend_reason: '推荐入库理由',
  audit_user_user_name: '审核人',
  audit_result: '审核结果',
  audit_user_remark: '备注',
  updated_at: '申请时间',
  supplier_resources: '优势资源平台',
  superior_resources: '优势资源平台',
});

export default messages;
